import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const taskCategoryType = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/task/{profile}/task-category-type',
    app: 'task',
    pk: 'id'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'task', model: 'task-category-type' }
    ),
    { }
  )
)()

export { taskCategoryType, TYPES }
